import { FC, PropsWithChildren } from 'react'

import { useTheme } from '@mui/material'
import { DataCard, DataCardProps } from '@/components/card'

import { DownloadCsv } from '../../DownloadCsv'
import { DownloadCsvDataProps } from '../../DownloadCsv/DownloadCsv'
import { StatisticsCsvHeaders } from '../cards/constants'
import { makeStatisticsFilename } from '../utils'

export type StatisticsCsvData =
  | DownloadCsvDataProps<Partial<Record<StatisticsCsvHeaders, unknown>>>
  | undefined

type StatisticsCardProps = PropsWithChildren & {
  csvData?: StatisticsCsvData
  printOptions?: {
    pageBreak?: boolean
  }
} & DataCardProps

export const StatisticsCard: FC<StatisticsCardProps> = ({
  children,
  csvData,
  title,
  printOptions,
  ...props
}) => {
  const theme = useTheme()

  return (
    <DataCard
      Sx={{
        card: {
          pageBreakBefore: printOptions?.pageBreak ? 'always' : 'auto',
          boxShadow: 'none'
        },
        header: {
          backgroundColor: theme.palette.statistics.panel.header.backgroundColor
        }
      }}
      title={title}
      headerPostfixActions={
        csvData &&
        title && (
          <DownloadCsv
            asIcon
            csvFileName={makeStatisticsFilename(title)}
            formatCsvRow={(row) => Object.values(row).map((value) => String(value))}
            {...csvData}
          />
        )
      }
      {...props}
    >
      {children}
    </DataCard>
  )
}
